/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import React, { useEffect, useRef } from "react";
import useNavigationStore from "@/lib/stores/useNavigationStore";
import clsx from "clsx";
import { usePathname } from "next/navigation";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { SanityDocument } from "@sanity/client";
import { socialMedias } from "./footer";
import TransitionLink from "./transition-link-button";

const links = [
  {
    label: "Home",
    link: "/",
  },
  {
    label: "Projects",
    link: "/projects",
  },
  {
    label: "Services",
    link: "/services",
  },
  {
    label: "About us",
    link: "/about-us",
  },
  {
    label: "Contact us",
    link: "/contact-us",
  },
];

interface MobileNavigationProps {
  socialMediaLinks: SanityDocument;
}

function MobileNavigation({
  socialMediaLinks,
}: Readonly<MobileNavigationProps>) {
  const { isMenuOpen, setIsMenuOpen } = useNavigationStore();
  const pathname = usePathname();
  const menuRef = useRef(null);
  const timeline = gsap.timeline();

  useGSAP(
    () => {
      if (isMenuOpen) {
        timeline.from(".nav-links", {
          opacity: 0,
          stagger: 0.2,
          y: 100,
          duration: 0.5,
        });
        timeline.from(".nav-platforms", {
          opacity: 0,
          stagger: 0.2,
          x: 50,
          duration: 0.3,
        });
        timeline.from(
          ".nav-platforms-account",
          { opacity: 0, stagger: 0.2, x: -50, duration: 0.3 },
          "<",
        );
      }
    },
    { scope: menuRef, dependencies: [isMenuOpen] },
  );

  useEffect(() => {
    window.scrollTo({ top: 0 });
    setIsMenuOpen(false);
  }, [pathname]);

  return (
    <section
      ref={menuRef}
      className={clsx(
        isMenuOpen ? "top-0" : "top-full",
        "fixed left-0 z-30 flex h-screen w-full flex-col items-center justify-end gap-5 bg-black py-14 duration-150 md:p-10 lg:hidden",
      )}
    >
      <div className="flex w-full flex-col items-start gap-2">
        {links.map(({ label, link }) => (
          <div key={label} className="h-auto w-full overflow-hidden">
            <TransitionLink
              label={label}
              href={link}
              className={clsx(
                pathname === link
                  ? "pointer-events-none text-orange-500"
                  : "text-cream",
                "nav-links h-auto font-Satoshi-Variable text-4xl font-light uppercase",
              )}
            />
          </div>
        ))}
      </div>
      <div className="flex min-h-52 w-full flex-col justify-end gap-2 px-5 font-Satoshi-Variable text-white">
        {socialMedias.map(
          ({ platform }) =>
            socialMediaLinks[platform] && (
              <div
                key={platform}
                className="flex w-full items-center justify-between uppercase"
              >
                <span className="nav-platforms font-semibold">{platform}</span>
                <span className="nav-platforms-account">
                  {socialMediaLinks[platform].username}
                </span>
              </div>
            ),
        )}
      </div>
    </section>
  );
}

export default MobileNavigation;
